export default "__VITE_ASSET__f628de18__"